import React from "react";
import PastScore from "../../components/PastScore";
import { Slider } from "@nextui-org/react";
import ScoreViewer from "../../components/scoreViewer";
import SizeResult from "../../components/SizeResult";
import Hint from "../../components/Hint";

const Results = ({
  score,
  currentRound,
  currentScore,
  previousScores,
  guessedValues,
  currentPlanet,
  correctSize,
  correctDistance,
  toNextACB,
}) => {

  return (
    <div className="flex justify-center items-center w-full font-orbitron">
      <div className="flex flex-col items-center gap-10 w-full">
        <h1 className="text-3xl text-center">
          Round {currentRound}
        </h1>
        <div className="flex flex-col items-center gap-10">
          <div className="flex md:justify-around justify-center items-center w-full">
            <div className="flex flex-col items-center gap-4">
              <h3 className="text-xl">Round Score:</h3>
              <h2 className="text-3xl font-bold">{score.totalScore}</h2>
              <p className="text-lg">Total Score: {currentScore}</p>
            </div>
            <div className="mt-10 grid-cols-2 gap-4x hidden md:flex md:gap-4">
              {previousScores.map((round, index) => (
                <PastScore
                  key={index}
                  name={round.name}
                  image={round.image}
                  score={round.score}
                  className="mb-4"
                />
              ))}
              <PastScore
                key={10}
                name={currentPlanet.name}
                image={currentPlanet.imgSrc.img}
                score={score.totalScore}
                className="mb-4"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="border border-gray-300 p-4 rounded-lg md:w-[450px]">
              <h4 className="text-lg font-semibold mb-2">Size</h4>
              <div className="flex items-center gap-2 mb-2">
                <b>Your Guess:</b>
                <ScoreViewer specificScore={score.sizeScore} />
              </div>
              <SizeResult
                currentGuess={guessedValues.size}
                actualGuess={correctSize}
              />
            </div>
            <div className="border border-gray-300 p-4 rounded-lg md:w-[450px] mt-6 md:mt-0">
              <h4 className="text-lg font-semibold mb-2">Distance</h4>
              <div className="flex items-center gap-2 mb-2">
                <b>Your Guess:</b>
                <ScoreViewer specificScore={score.distanceScore} />
              </div>
              <div className="relative mb-2">
                <div className="flex items-center gap-4">
                  <Slider
                    size="md"
                    step={0.000001}
                    maxValue={0.000478}
                    minValue={0}
                    color="foreground"
                    classNames={{
                      base: "max-w-md w-full",
                      label: "text-medium font-orbitron",
                    }}
                    value={guessedValues.distance}
                    renderValue={({ children, ...props }) => (
                      <output {...props}></output>
                    )}
                  />
                </div>
                <div className="flex items-center gap-4 absolute w-full bottom-0">
                  <Slider
                    size="md"
                    step={0.000001}
                    maxValue={0.000478}
                    minValue={0}
                    classNames={{
                      base: "max-w-md",
                      filler: "bg-transparent",
                      track: "bg-transparent border-transparent",
                      labelWrapper: "mb-2",
                      label: "font-medium text-default-700 text-medium",
                      value: "font-medium text-default-500 text-small",
                      thumb: ["transition-size", "bg-success-500"],
                      step: "data-[in-range=true]:bg-black/30 dark:data-[in-range=true]:bg-white/50",
                    }}
                    value={correctDistance}
                    renderValue={({ children, ...props }) => (
                      <output {...props}></output>
                    )}
                  />
                </div>
              </div>
              <p className="text-gray-600 text-sm">
                {guessedValues.distance} /{" "}
                <span className="text-success-500">{correctDistance}</span> light
                years
              </p>
            </div>
          </div>
        </div>

        <div className="flex w-fit gap-4">
          <Hint
            text="Or press spacebar to go to the next round!"
            icon="/assets/images/keys/Spacebar.png"
            function={toNextACB}
            condition={currentRound === 1}
          />
          <button
            className="btn-primary h-fit !justify-self-center"
            onClick={toNextACB}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Results;
